module.exports = __webpack_public_path__ + "img/asiatic-lilly.20c2d540.webp";